import React, { useState } from 'react'
import styled from 'styled-components'
import { getThemeStore, setThemeStore, getLanguageStore } from '../storage'
import Row from '../../row'
import Iconfont from '../../tntd-icon'

const Theme = styled.li`
  margin-top: 20px;
  .user-info-body-theme-row {
    > div {
      width: 90px;
      height: 36px;
      line-height: 36px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      border-radius: 2px;
      text-align: center;
      cursor: pointer;
      position: relative;
      &.themeS3 {
        background-image: linear-gradient(180deg, #213f83 0%, #0f75d6 100%);
        color: #ffffff;
      }
      &.themeS2 {
        background: #17233d;
        color: #ffffff;
      }
      &.themeS1 {
        background: #ffffff;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
        color: #17233d;
      }
      .icon-checked-wrap {
        width: 14px;
        height: 14px;
        border-radius: 100%;
        background: #126bfb;
        position: absolute;
        top: -5px;
        right: -5px;
        &:after {
          content: '';
          width: 4px;
          height: 6px;
          border-color: #ffffff;
          border-width: 0 1px 1px 0;
          border-style: solid;
          transform: rotate(45deg);
          position: absolute;
          top: 3px;
          left: 5px;
        }
      }
    }
  }
`

const themes = [
  { value: 'themeS3', label: '科技蓝', enLabel: 'Blue' },
  { value: 'themeS2', label: '暗夜黑', enLabel: 'Black' },
  { value: 'themeS1', label: '极致白', enLabel: 'White' },
]

export default (props) => {
  const { onChange } = props

  const getTheme = () => {
    let theme = getThemeStore() || props.theme || 'themeS3'
    return themes.some(({ value }) => value === theme) ? theme : 'themeS3'
  }

  const [theme, setTheme] = useState(getTheme())
  const changeTheme = (theme) => {
    setTheme(theme)
    setThemeStore(theme)
    onChange(theme)
  }

  return (
    <Theme>
      <Row type="flex" justify="space-between" className="user-info-body-theme-row">
        {themes.map(({ value, label, enLabel }) => (
          <div className={value} onClick={changeTheme.bind(this, value)}>
            {getLanguageStore() === 'en' ? enLabel : label}
            {theme === value && <span className="icon-checked-wrap"></span>}
          </div>
        ))}
      </Row>
    </Theme>
  )
}
